import EmiCollected from './EmiCollected';
import PtpOverViews from './PtpOverViews';
import TotalCallData from './TotalCallData';
import InprogressScreen from './InprogressScreen';
import ErrorScreen from '../ErrorScreen';

const DashboardBody = ({ cycle, loading }: { cycle: string; loading: boolean }) => {
  const isAllocationInprogress = false;
  const isCycleAllocationInprogress = false;
  const isErrorOccured = false;
  const toShowEmiCollected = true;
  const toShowPTPOverviews = true;
  const toShowTotalCallData = false;

  return (
    <div>
      {isErrorOccured ? (
        <ErrorScreen />
      ) : isAllocationInprogress ? (
        <InprogressScreen
          primaryText={'Allocation is in progress.'}
          secondaryText={'Please visit after some time'}
        />
      ) : isCycleAllocationInprogress ? (
        <InprogressScreen
          primaryText={'Cycle Allocation is in progress.'}
          secondaryText={'Please visit after some time'}
        />
      ) : (
        <div className="flex flex-row justify-start gap-6 mt-11">
          {toShowEmiCollected && <EmiCollected loading={loading} />}
          {toShowPTPOverviews && <PtpOverViews loading={loading} />}
          {toShowTotalCallData && <TotalCallData />}
        </div>
      )}
    </div>
  );
};

export default DashboardBody;
